import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * État vide : affiché quand une requête a réussi mais ne renvoie aucune donnée.
 *
 * Remplace le pattern `list.length ? list : buildMock()` qui affichait des
 * données fictives dès qu'une liste légitimement vide arrivait.
 */
@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.css',
})
export class EmptyStateComponent {
  /** Icône Font Awesome (sans le préfixe `fa fa-`). */
  @Input() icon = 'inbox';

  /** Clé i18n du titre. */
  @Input() titleKey = 'COMMON.EMPTY_TITLE';

  /** Clé i18n du message explicatif. */
  @Input() messageKey = 'COMMON.EMPTY_MESSAGE';

  /** Clé i18n du bouton d'action. Laisser vide pour masquer le bouton. */
  @Input() actionKey = '';
}
